import firebase from 'firebase';
import _ from 'lodash';

import View from '../../_components/view/view.js';
import newsManagerTpl from './news-manager.tpl.html';
import './news-manager.styles.less';

import NewsMgrItemView from './item/news-mgr-item.view.js';

class NewsManagerView extends View {

	constructor (data, options) {
		super(newsManagerTpl, data, options);

		this.newsViews = [];
		this.newsRef = firebase.database().ref('news/');
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			newsList: '.news-list',
			addNewTitleInput: '.add-new input[name="title"]',
			addNewTextarea: '.add-new textarea',
			btnAddNew: '.btn-add-new',
			btnUpdateNew: '.btn-update-new',
			btnCancelEdit: '.btn-cancel-edit-new'
		});
	}

	render(data) {
		super.render(data);
		this.initializeNewsData();
	}

	initializeNewsData() {
		this.newsRef.on('value', __news => {
			this.updateNewsList(__news);
		});
	}

	initializeEvents() {
		super.initializeEvents();
		
		this.ui.btnAddNew.click(() => this.addNew());
		this.ui.btnUpdateNew.click(() => this.updateNew());
		this.ui.btnCancelEdit.click(() => this.hideEditNew());
	}

	updateNewsList(__news) {
		this.removeNewsList();

		__news.forEach( __new => {
			let
			newView = new NewsMgrItemView(__new.val(), {__new: __new});
			newView.on('edit:new', this.showEditNew.bind(this));
			this.newsViews.push(newView);
			newView.appendTo(this.ui.newsList);
		});
	}

	removeNewsList() {
		_.forEach(this.newsViews, newView => {
			newView.remove();
			newView.off('edit:new');
		});

		this.newsViews = [];
	}

	showEditNew(__new) {
		let newData = __new.val();
		this.editNewRef = __new.ref;

		this.ui.addNewTitleInput.val(newData.title);
		this.ui.addNewTextarea.val(newData.text);
		this.ui.btnAddNew.hide();
		this.ui.btnUpdateNew.show();
		this.ui.btnCancelEdit.show();
	}

	addNew() {
		firebase.database().ref('news/').push({
			created: new Date().getTime(),
			title: this.ui.addNewTitleInput.val(),
			text: this.ui.addNewTextarea.val()
		})
		.then(() => this.cleanForm());
	}

	updateNew() {
		this.editNewRef.update({
			updated: new Date().getTime(),
			title: this.ui.addNewTitleInput.val(),
			text: this.ui.addNewTextarea.val()
		})
		.then(() => {
			this.hideEditNew();
		});
	}

	hideEditNew() {
		this.cleanForm();
		this.ui.btnUpdateNew.hide();
		this.ui.btnCancelEdit.hide();
		this.ui.btnAddNew.show();
	}

	cleanForm() {
		this.ui.addNewTitleInput.val('');
		this.ui.addNewTextarea.val('');
	}

	/*onShow() {

	}*/


	remove() {
		super.remove();
		this.removeNewsList();
	}

}

export default NewsManagerView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/news/news-manager.view.js